import { SAVE_LANGUAGE_LIST } from "../types/action-type";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

export default function languageReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_LANGUAGE_LIST:
      return {
        ...state,
        loading: true,
        list: action.data,
      };
    default:
      return state;
  }
}
